import React from 'react';
import { personalInfo } from '../data/mock';
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-6 border-t border-border">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="space-y-2 text-center md:text-left">
            <p className="font-mono text-lg font-bold">
              {personalInfo.name}<span className="text-cyan-500">.</span>
            </p>
            <p className="text-sm text-muted-foreground">
              © {currentYear} All rights reserved.
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href={`mailto:${personalInfo.email}`}
              className="h-10 w-10 rounded-full border border-border hover:border-cyan-500 hover:text-cyan-500 flex items-center justify-center transition-all"
              aria-label="Email"
            >
              <Mail className="h-5 w-5" />
            </a>
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="h-10 w-10 rounded-full border border-border hover:border-cyan-500 hover:text-cyan-500 flex items-center justify-center transition-all"
              aria-label="GitHub"
            >
              <Github className="h-5 w-5" />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="h-10 w-10 rounded-full border border-border hover:border-cyan-500 hover:text-cyan-500 flex items-center justify-center transition-all"
              aria-label="LinkedIn"
            >
              <Linkedin className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
